export enum InviteStatusEnum {
    Pending = 0,
    Sent = 1,
    PendingDelete = 2,
    InviteRegisteredUser = 3,
    Blocked = 4,
}